  // AuthContext.js
  import React, { createContext, useContext, useState, useEffect } from 'react';

  const AuthContext = createContext();

  export const AuthProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [userRole, setUserRole] = useState(null);
    const [token, setToken] = useState(localStorage.getItem('token') || null);
    const [loading, setLoading] = useState(true); // Estado de carga

    useEffect(() => {
      const savedToken = localStorage.getItem('token');
      const savedRole = localStorage.getItem('role');

      if (savedToken) {
        setToken(savedToken);
        setIsAuthenticated(true); // Cambia el estado a auténtico
        setUserRole(savedRole); // Establece el rol del usuario
      }

      setLoading(false); // Indica que se ha terminado de cargar
    }, []);

    const login = (token, role) => {
      setIsAuthenticated(true);
      setUserRole(role);
      setToken(token);
      localStorage.setItem('token', token); // Guardar el token en el almacenamiento local
      localStorage.setItem('role', role); // Guardar el rol en el almacenamiento local
    };

    const logout = () => {
      setIsAuthenticated(false);
      setUserRole(null);
      setToken(null);
      localStorage.removeItem('token'); // Eliminar el token del almacenamiento local
      localStorage.removeItem('role'); // Eliminar el rol del almacenamiento local
    };

    // Si está cargando, no renderizar nada (puedes cambiar esto por un spinner si lo deseas)
    if (loading) {
      return null; // O <LoadingSpinner />
    }

    return (
      <AuthContext.Provider value={{ isAuthenticated, userRole, token, login, logout }}>
        {children}
      </AuthContext.Provider>
    );
  };

  export const useAuth = () => {
    return useContext(AuthContext);
  };
